import * as React from 'react';

import { IVerticalArrowProps, VerticalArrow } from '../../../VerticalArrow';

import * as styles from './styles.css';

export function Arrow(props: IVerticalArrowProps) {
  return <VerticalArrow {...props} containerClass={styles['arrow']} />;
}
